<template>
	<div v-if="!processing" class="loader" :class="classObject">
		<span v-if="$attrs.text" v-html="$attrs.text"></span>
		<svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
			<g fill="none" fill-rule="evenodd">
				<g transform="translate(1 1)" stroke-width="2">
					<circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
					<path d="M36 18c0-9.94-8.06-18-18-18">
						<animateTransform
							attributeName="transform"
							type="rotate"
							from="0 18 18"
							to="360 18 18"
							dur="1s"
							repeatCount="indefinite"/>
					</path>
				</g>
			</g>
		</svg>
	</div>
</template>
<script>
export default {
	props: {
		processing: {
			type: Boolean,
			default() {
				return false;
			}
		}
	},

	computed: {
		classObject() {
			return {
				processing: this.processing,
			};
		},
	}
};
</script>
